import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@services/auth.service'
import { AccountService } from '@services/account.service'
import { AccountProductType } from '@models/account.model'

export const portalEnrollmentRedirectGuard: CanActivateFn = (route, state) => {
	const router = inject(Router)
	const authService = inject(AuthService)
	const accountService = inject(AccountService)
	const processId = route.paramMap.get('numProcess')
	const isAuthenticated = authService.token != null && !authService.expired

	if (!processId) {
		return router.createUrlTree(['/portal', route.paramMap.get('domain') || 'default'])
	}

	if (!isAuthenticated) {
		authService.resetSession(false)
		return router.createUrlTree(['/auth/signin'], { queryParams: { redirect: state.url } })
	}

	// Visitante (spec 048, RF 19): o link curto leva ao detalhe do processo na área dele — também quem é fornecedor e
	// visitante e está no produto do visitante. A etapa de comprovação fica com o guard da área.
	if (accountService.isVisitor && (!accountService.isSupplier || accountService.currentProductVisitor)) {
		accountService.syncRoleProducts()
		accountService.changeProduct(AccountProductType.VIS)
		return router.createUrlTree(['/visitor/processes', processId])
	}

	if (!accountService.isSupplier) {
		return router.createUrlTree(['/auth/role-select'], {
			queryParams: {
				preserve: 'true'
			}
		})
	}

	accountService.changeProduct(AccountProductType.SUP)

	return router.createUrlTree(['/supplier/board'], {
		queryParams: { processId }
	})
}
